import moment from "moment";

export const CSV_DATE_FORMAT = "MM/DD/YY hh:mm A";
export const DISPLAY_DATE_FORMAT = "MMM Do YY, h:mm:ss a";
export const DEFAULT_API_ENDPOINT = "cardio_cloud";
export const API_ENDPOINTS = {
  galen_cloud: "https://api.galencloud.com",
  cardio_cloud: "https://webportalapi.cardioatx.com",
  cardio_sean: "https://cardapi.sometimescreekventures.com", // This will be updated dynamically from Firebase
  cardio_dev: "https://api-cardiodev.com"
};

let endpointUpdateCallbacks = [];

export const subscribeToEndpointUpdates = (callback) => {
  endpointUpdateCallbacks.push(callback);
  return () => {
    const index = endpointUpdateCallbacks.indexOf(callback);
    if (index > -1) {
      endpointUpdateCallbacks.splice(index, 1);
    }
  };
};

// Function to notify all subscribers of endpoint updates
const notifyEndpointUpdate = () => {
  endpointUpdateCallbacks.forEach(callback => {
    try {
      callback(API_ENDPOINTS);
    } catch (error) {
      console.error('Error in endpoint update callback:', error);
    }
  });
};

// Function to get current API base URL
export const getCurrentApiBaseUrl = () => {
  const selectedVersion = localStorage.getItem('selected-api-version') || DEFAULT_API_ENDPOINT;
  const currentEndpoint = API_ENDPOINTS[selectedVersion] || API_ENDPOINTS[DEFAULT_API_ENDPOINT];
  return currentEndpoint;
};

// Function to get current v3 API base URL.
// Derives the "-v3" host from the active endpoint, e.g.
// https://webportalapi.cardioatx.com -> https://webportalapi-v3.cardioatx.com
export const getV3ApiBaseUrl = () => {
  const base = getCurrentApiBaseUrl();
  return base.replace(/^(https?:\/\/[^.]+)(\.)/, "$1-v3$2");
};

export const updateApiEndpoint = (endpointKey, newEndpoint) => {
  if (endpointKey && newEndpoint && typeof newEndpoint === 'string') {
    API_ENDPOINTS[endpointKey] = newEndpoint;
    console.log(`Updated ${endpointKey} endpoint to:`, newEndpoint);
    
    notifyEndpointUpdate();
    
    const selectedVersion = localStorage.getItem('selected-api-version') || DEFAULT_API_ENDPOINT;
    if (endpointKey === selectedVersion) {
      updateApiBaseUrl();
      console.log(`Refreshed API_BASE_URL to use updated ${endpointKey} endpoint`);
    }
  } else {
    console.warn(`Invalid endpoint update: ${endpointKey} = ${newEndpoint}`);
  }
};

// Legacy export for backward compatibility - this will be updated dynamically
export let API_BASE_URL = getCurrentApiBaseUrl();

// Function to update API_BASE_URL (for runtime updates)
export const updateApiBaseUrl = () => {
  API_BASE_URL = getCurrentApiBaseUrl();
  return API_BASE_URL;
};

// Initialize the API_BASE_URL
updateApiBaseUrl();

export const TENANT_DOMAIN = "ats-dev2.galencloud.com";
export const APP_TYPE = "DEVICE";
export const APP_VERSION = "3";

export const REDUCERS = {
  LOADING: { loading: true, error: false },
  SUCCESS: { loading: false, error: false },
  ERROR: { loading: false, error: true },
};

export const MESSAGES = {
  FORM_SUBMITTED_SUCCESSFULLY: "Form submitted successfully.",
  FORM_UPDATED_SUCCESSFULLY: "Form updated successfully.",
  DATA_DELETED_SUCCESSFULLY: "Data deleted successfully.",
  SOMETHING_WENT_WRONG: "Something went wrong.",
  FILE_UPLOADED_SUCCESSFULLY: "File uploaded successfully.",
  LOGIN_SUCCESSFUL: "Login successfully",
  RESET_MAIL_SUCCESSFUL: "We have sent OTP code to your email address.",
  INCORRECT_PASSWORD: "Invalid login credentials.",
  PASSWORD_UPDATED_SUCCESSFUL: "Password updated successfully."
};

export const USER_ROLES = [
  { key: "TenantAdmin", value: "Manufacturer Admin" },
  { key: "TenantUser", value: "Manufacturer User" },
  { key: "SupplierAdmin", value: "Company Admin" },
  { key: "SupplierUser", value: "Company User" },
  { key: "PracticeAdmin", value: "Facility Admin" },
  { key: "PracticeUser", value: "Facility User" },
  { key: "Patient", value: "Care Team" },
  { key: "Guest", value: "Guest" }
];

export const FILTER_USER_ROLES = [
  { key: "all", value: "All" },
  ...USER_ROLES
];

export const PRACTICE_USER_ROLES = ["PracticeAdmin", "PracticeUser", "Patient"];

export const GENDER = ["male", "female"];

export const PAGINATION_DETAILS = {
  pageNumber: 0,
  pageSize: 25,
};

export const PAGE_SIZES = [5, 10, 25, 100];

export const PATIENT_PASSWORD = "Md@995353";

export const CUSTOM_FIELD_DEFAULT_VALUE = [
  { key: "TimeZone", value: "Central Standard Time" },
  { key: "Privacy Policy Accepted", value: "No" },
  { key: "Enable USER Alerts", value: ["App"] },
  { key: "Plot_range_default", value: "1 Hr" },
  { key: "Enable Reports", value: ["None"] },
  { key: "Alexa_name", value: "Alexa name" },
  { key: "DayLight_Savings", value: "Yes" },
  { key: "TimeStamp-UP", value: moment() },
  { key: "Change Password", value: "Yes" },
  { key: "Location", value: "Location" },
  { key: "Guest Account", value: "No" },
  { key: "T&C accepted", value: "No" },
  { key: "APP_view", value: "GW" },
];
// { key: "Migration Date", value: moment() },

export const DEFAULT_TIMEZONE = 'CDT';
export const DEFAULT_TIMEOFFSET = '-5';
export const DEFAULT_TIME = 'Central Standard Time';
export const DEFAULT_UTC_TIME = 'America/Chicago';
export const UTC_TIME_ZONE = 'America/Scoresbysund';

export const THRESHOLD_DEFAULT_VALUES = {
  AlertMinhr: 45,
  AlertMaxhr: 100,
  AlertMinrr: 9,
  AlertMaxrr: 30,
  // AlertMinst: 0,
  AlertMaxst: 5,
  // AlertMinmt: ,
  AlertMaxmt: 5,
}

export const PARAMS_DEFAULT_VALUES = {
  BpfSelect: 2,
  GainSelect: "M",
  // HrSqlSigC: 9,
  // RrSqlSigC: 30,
  // AlertMinst: 0,
  // HrGainC: 5,
  // RrGainC: ,
  // ParamsLastupdate: 5,
}

export const GRAPH_DATA_REQUEST = {
  "deviceDataModelId": "",
  "dataPropertyCode": "",
  "rangeStartDateTime": null,
  "rangeEndDateTime": null,
  "buckets": null,
  "options": {
    "aggregationType": null,
    "groupingPropertyCode": "Timestamp",
    "groupType": "Minute",
    "defaultSelect": "Last"
  },
  "deviceCriteria": [
    {
      "key": "DevidPvital", 
      "operator": "Equal", 
      "value": "", 
      "valueFrom": null, 
      "valueTo": null
    },
    {
      "key": "Timestamp",
      "operator": "Between",
      "valueFrom": "",
      "valueTo": "",
    },
  ],
  "ownerFilter": {
    "users": [],
    "practices": [],
    "suppliers": [],
    "tenantId": null,
    "empty": false
  },
  "offset": "",
  "dayLightSaving": "",
};

export const FDA_HIDDEN_ROUTES = [
  "/alert-logs",
  "/diagnostic-panel", 
  "/management"
];

